module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/zh-hans-card-drag.795c48a1e24e353f59af.gif";